<template>
  <div class="text-box-date">
    <div v-show="showTitle" class="flex items-center justify-start mb-2">
      <span class="mr-2">{{ title }}</span>
      <span v-show="required" class="required"> * </span>
    </div>
    <div class="flex items-center justify-between">
      <flat-pickr
        class="w-32"
        :config.sync="configTimePicker"
        v-model="inputValue"
        :disabled="isDisabledInput"
      ></flat-pickr>
    </div>
  </div>
</template>

  <script>
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { Japanese } from "flatpickr/dist/l10n/ja.js";
import { DeviceInfoMixin, ColorMixin } from "@/mixins";

export default {
  name: "M.TextBoxDate",
  mixins: [DeviceInfoMixin, ColorMixin],
  props: {
    title: {
      type: String,
      required: false
    },
    value: { required: false },
    required: {
      type: Boolean,
      required: false,
      default: false
    },
    showTitle: {
      type: Boolean,
      required: false,
      default: false
    },
    minDate: {
      type: String,
      required: false,
      default: "",
    }
    ,
    maxDate: {
      type: String,
      required: false,
      default: ""
    }
  },
  data() {
    return {
      inputValue: null,
      configTimePicker: {
        enableTime: false,
        locale: Japanese,
        dateFormat: "Y/m/d",
      },
    }
  },
  components: {
    flatPickr
  },
  watch: {

  },
  computed: {
    isDisabledInput() {
      return false;
    }
  },
  methods: {

  },
  created() {
    if (this.minDate.length > 0) {
      this.configTimePicker.minDate = this.minDate;
    }

    if (this.maxDate.length > 0) {
      this.configTimePicker.maxDate = this.maxDate;
    }

  }
}
  </script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";
@import "@/assets/scss/aisea/_typography.scss";

.text-box-date {
  .required {
    color: $aisea-red;
  }
}
</style>